module.exports = __webpack_public_path__ + "img/hot-img3.8a7caacc.png";